/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Photo_Too_LargeInputs */

const en_us2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the photos is too large. Take it again in the app.`)
};

const pt_br2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma das fotos ficou grande demais. Tire de novo pelo app.`)
};

const es_419_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una de las fotos es demasiado grande. Tómala de nuevo en la app.`)
};

const pt_pt2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma das fotografias ficou demasiado grande. Tira-a outra vez na app.`)
};

const fr_fr2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une des photos est trop lourde. Reprends-la dans l'appli.`)
};

const de_de2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eines der Fotos ist zu groß. Nimm es in der App neu auf.`)
};

const it_it2_body_assessment_photo_too_large = /** @type {(inputs: Body_Assessment_Photo_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una delle foto è troppo grande. Scattala di nuovo nell'app.`)
};

/**
* | output |
* | --- |
* | "One of the photos is too large. Take it again in the app." |
*
* @param {Body_Assessment_Photo_Too_LargeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_photo_too_large = /** @type {((inputs?: Body_Assessment_Photo_Too_LargeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Photo_Too_LargeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_photo_too_large(inputs)
	if (locale === "es-419") return es_419_body_assessment_photo_too_large(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_photo_too_large(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_photo_too_large(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_photo_too_large(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_photo_too_large(inputs)
	return en_us2_body_assessment_photo_too_large(inputs)
});
export { body_assessment_photo_too_large as "body_assessment.photo_too_large" }